// src/components/Question.tsx

import React from 'react';
import { Question as QuestionType } from '../types';


interface QuestionProps {
  question: QuestionType;
  onAnswer: (questionId: number, answer: string) => void;
  selectedAnswer: string;
}

const QuestionComponent: React.FC<QuestionProps> = ({ question, onAnswer, selectedAnswer }) => {

  return (
    <div className="w-full max-w-2xl mx-auto bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-6">
        <h3 className="text-lg font-semibold mb-6">{question.text}</h3>
        <div className="space-y-4">
          {Object.keys(question.scores).map(option => (
            <button
              key={option}
              onClick={() => onAnswer(question.id, option)}
              className={`
                w-full py-3 px-4 text-left rounded-md border transition-all duration-300 ease-in-out
                ${
                  selectedAnswer === option
                    ? 'bg-indigo-600 text-white border-indigo-600 shadow-lg transform scale-105'
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-indigo-50 hover:border-indigo-300 hover:shadow-md'
                }
                focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50
              `}
            >
              <span className="block transition-transform duration-300 ease-in-out transform group-hover:translate-x-1">
                {option}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuestionComponent;
